import { useState, useEffect, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  TextField,
  Button,
  IconButton,
  MenuItem,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AddIcon from "@mui/icons-material/Add";
import * as services from "../../services/services";
import * as dropdown from "../../services/dropdown_service";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { transformPet } from "../../utils/reModelPet";
import { jwtDecode } from "jwt-decode";
import { Snackbar, Alert } from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import { HeaderContext } from "../../App";
const ServiceVaccinePage = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const decoded = jwtDecode(accessToken);
  const { id } = useParams(); // รับ petId จาก route
  const [pet, setPet] = useState(null);
  const [vaccine_dropdown, setVaccineDropdown] = useState([]);
  const [detail, setDetail] = useState([]); // ข้อมูลหมอคนเดียว
  const [open, setOpen] = useState(false);
  const { setTitle, setShowBack } = useContext(HeaderContext);

  useEffect(() => {
    setTitle("บันทึกการฉีดวัคซีน");
    setShowBack(true);

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, [setTitle, setShowBack]);

  const [vaccineList, setVaccineList] = useState([
    {
      date: new Date().toISOString().split("T")[0], // <-- วันที่ปัจจุบัน
      image: null,
      vaccineName: "",
      lotNo: "",
      expDate: null,
      nextDate: null,
    },
  ]);
  const [vet, setVet] = useState({
    name: "",
    license_no: "",
    hospital: "",
    note: "",
  });

  useEffect(() => {
    const fetchPet = async () => {
      try {
        const res = await services.getPetBowById(id);
        console.log(res);
        setPet(res.data || null);

        // โหลด dropdown วัคซีนหลังได้ข้อมูลสัตว์
        if (res.data?.type_id) {
          const vaccineRes = await dropdown.getVaccine(res.data.type_id);
          setVaccineDropdown(vaccineRes.data.results || []);
        }
      } catch (err) {
        console.error(err);
      }
    };

    if (id) fetchPet();
  }, [id]);

  const fetchData = useCallback(async () => {
    try {
      const res = await services.getUserDetail();
      if (res.data.success) {
        setDetail(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    const doctor = detail;
    setVet({
      doctor_id: doctor.id,
      name: doctor.name,
      lastname: doctor.lastname,
      hospital: doctor?.hospital?.name,
      license_no: doctor?.license_no,
      note: "",
    });
  }, [detail]);
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      if (!file) return resolve(null);

      // ถ้าเป็น string อยู่แล้ว ให้ return ทันที
      if (typeof file === "string") return resolve(file);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // ตัด prefix ออก
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });

  // --- บันทึกการฉีดวัคซีน ---
  const saveVaccine = async () => {
    try {
      if (!pet) return;
      const items = await Promise.all(
        vaccineList.map(async (v) => ({
          product: v.vaccineName,
          lot_number: v.lotNo,
          expiration_date: v.expDate,
          appointed_date: v.nextDate,
          photos: [
            {
              photo: v.image ? await toBase64(v.image) : "",
              is_label: true,
            },
          ],
        }))
      );

      const payload = {
        pet: pet.id,
        date: vaccineList[0].date,
        note: vet.note,
        items,
        vet_name: vet.name + "  " + vet.lastname,
        vet_license_number: vet.license_no,
        vet_hospital_name: vet.hospital,
      };

      // ส่งไป API
      const res = await services.putVaccineRecordsBow(payload);
      if (res.status === 201) {
        if (res.data.items) {
          const updatedVaccineList = vaccineList.map((v, index) => {
            const backendItem = res.data.items[index];
            return {
              ...v,
              image: backendItem?.photos[0]?.photo || v.image,
              id: backendItem?.id || v.id,
            };
          });

          setVaccineList(updatedVaccineList);
          const itemsWithLink = updatedVaccineList.map((v) => ({
            product: v.vaccineName,
            lot_number: v.lotNo,
            expiration_date: new Date(v.expDate),
            appointed_date: new Date(v.nextDate),
            photos: [
              {
                photo: v.image,
                is_label: true,
              },
            ],
          }));
          const vaccines = itemsWithLink.map((v) => ({
            vetId: decoded.id,
            product: String(v.product),
            lotNumber: v.lot_number || "",
            expirationDate: v.expiration_date
              ? new Date(v.expiration_date)
              : null,
            appointedDate: v.appointed_date ? new Date(v.appointed_date) : null,
            photo: v.photos[0].photo || "",
          }));

          let petData = transformPet(pet, decoded.hospitalId);
          let payload = {
            pet: petData,
            treatments: [
              {
                serviceType: "vaccine",
                serviceDate: new Date(vaccineList[0].date),
                handledById: decoded.id,
                hospitalId: decoded.hospitalId,
                note: vet.note,
              },
            ],
            vaccines,
          };
          const resTreat = await services.createTreatments(payload);
          if (resTreat.data.success) {
            setOpen(true); // เปิด Snackbar
            setTimeout(() => {
              navigate(`/search/pet`);
            }, 3000); // รอ 1 วินาทีให้ Snackbar โผล่
          }
        }
      }
    } catch (err) {
      console.error(err);
      alert("บันทึกไม่สำเร็จ");
    }
  };
  if (!pet)
    return <Typography sx={{ p: 2 }}>กำลังโหลดข้อมูลสัตว์เลี้ยง...</Typography>;

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={pet.image || "/no-image.png"}
                alt={pet.name}
                style={{ width: "70%", borderRadius: 8 }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography variant="h6">ชื่อ: {pet.name}</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography>ชนิด: {pet.type}</Typography>
              <Typography>สายพันธุ์: {pet.breed}</Typography>
              <Typography>
                เพศ:{" "}
                {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[pet.gender] || "-"}
              </Typography>
              <Typography>วันเกิด: {pet.birthdate}</Typography>
            </Grid>
          </Grid>
        </Paper>

        {/* ฟอร์มวัคซีน */}
        {vaccineList.map((item, index) => (
          <Paper key={index} sx={{ p: 2, mb: 3 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
              รายละเอียดวัคซีน
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="วันที่ได้รับวัคซีน"
                  fullWidth
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={item.date}
                  onChange={(e) => {
                    const newList = [...vaccineList];
                    newList[index].date = e.target.value;
                    setVaccineList(newList);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={{ mb: 1 }}>แนบรูป Vaccine Sticker*</Typography>
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    padding: 4,
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <IconButton component="label">
                    <PhotoCamera fontSize="large" />
                    <input
                      hidden
                      accept="image/*"
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const newList = [...vaccineList];
                          newList[index].image = file;
                          setVaccineList(newList);
                        }
                      }}
                    />
                  </IconButton>
                  <Typography variant="body2" sx={{ mt: 1, color: "#888" }}>
                    อัพโหลดรูปภาพขนาดไม่เกิน 5MB
                  </Typography>

                  {/* เพิ่มส่วนแสดงรูปทันที */}
                  {item.image && (
                    <Box sx={{ mt: 2 }}>
                      <img
                        src={
                          typeof item.image === "string"
                            ? `data:image/jpeg;base64,${item.image}`
                            : URL.createObjectURL(item.image)
                        }
                        alt="vaccine"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  label="ชื่อวัคซีน / brand name vaccine"
                  fullWidth
                  value={item.vaccineName} // <-- ต้องตรงกับค่าใน MenuItem.value
                  onChange={(e) => {
                    const selected = vaccine_dropdown.find(
                      (v) => v.value === e.target.value
                    );

                    const newList = [...vaccineList];
                    newList[index].vaccineName = selected.value; // <-- ใช้ selected.value
                    newList[index].vaccineDetail = selected;

                    // คำนวณ nextDate
                    if (selected?.context?.effective_days) {
                      const startDate = new Date(item.date);
                      startDate.setDate(
                        startDate.getDate() + selected.context.effective_days
                      );
                      newList[index].nextDate = startDate
                        .toISOString()
                        .split("T")[0];
                    }

                    setVaccineList(newList);
                  }}
                >
                  {vaccine_dropdown.map((v) => (
                    <MenuItem key={v.value} value={v.value}>
                      {" "}
                      {/* <-- value ต้องตรงกับ item.vaccineName */}
                      <img
                        src={v?.context?.photo}
                        alt={v.label}
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                      {v.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Lot No."
                  fullWidth
                  value={item.lotNo}
                  onChange={(e) => {
                    const newList = [...vaccineList];
                    newList[index].lotNo = e.target.value;
                    setVaccineList(newList);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="วันหมดอายุ / EXP date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  value={item.expDate}
                  onChange={(e) => {
                    const newList = [...vaccineList];
                    newList[index].expDate = e.target.value;
                    setVaccineList(newList);
                  }}
                />
              </Grid>
              {item.vaccineName && (
                <Grid item xs={12} md={6}>
                  <Typography sx={{ fontSize: 16, mt: 4, mb: 1 }}>
                    วันที่ครบระยะการป้องกัน
                  </Typography>
                  <Typography sx={{ fontSize: 14, mb: 1 }}>
                    อ้างอิงจากวันที่ได้รับยา โดยหลังจากนี้ ควรได้รับยาอีกครั้ง
                  </Typography>
                  <Typography sx={{ fontSize: 16, mb: 1, color: "#ef771e" }}>
                    {item.nextDate
                      ? item.nextDate.split("-").reverse().join("-")
                      : ""}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <TextField
                  label="วันที่นัดครั้งถัดไป"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  value={item.nextDate}
                  onChange={(e) => {
                    const newList = [...vaccineList];
                    newList[index].nextDate = e.target.value;
                    setVaccineList(newList);
                  }}
                />
              </Grid>
            </Grid>
          </Paper>
        ))}

        {/* <Button
          startIcon={<AddIcon />}
          variant="outlined"
          onClick={addVaccineList}
          sx={{ mb: 4 }}
        >
          เพิ่มรายการ
        </Button> */}
        <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
          สัตวแพทย์
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="สัตวแพทย์ผู้ให้บริการ"
              value={`${vet.name} ${vet.lastname}`}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="เลขที่ใบอนุญาต"
              value={vet.license_no}
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="ชื่อสถานพยาบาล"
              value={vet.hospital}
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="ข้อมูลเพิ่มเติม"
              value={vet.note}
              onChange={(e) =>
                setVet((prev) => ({ ...prev, note: e.target.value }))
              }
              multiline
              minRows={3}
              fullWidth
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            sx={{
              width: "100%",
              maxWidth: 400,
              color: "#fff",
              fontWeight: "bold",
              fontSize: 16,
              background: "linear-gradient(90deg, #ef771e 0%, #e04b22 100%)",
              "&:hover": {
                background: "linear-gradient(90deg, #e04b22 0%, #ef771e 100%)", // สลับสีตอน hover
              },
            }}
            onClick={saveVaccine}
          >
            บันทึกการฉีดวัคซีน
          </Button>
        </Box>

        <Box sx={{ height: 50 }} />
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={3000} // 3 วินาที
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          icon={<PetsIcon style={{ color: "green" }} />}
          sx={{ alignItems: "center", fontSize: 16 }}
        >
          บันทึกข้อมูลสำเร็จ
        </Alert>
      </Snackbar>
    </>
  );
};

export default ServiceVaccinePage;
